'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var isObject = exports.isObject = function isObject(someVar) {
  return someVar instanceof Object;
};
var isCityObject = exports.isCityObject = function isCityObject(someVar) {
  return "cityId" in someVar;
};
var appendSlashIfNeeded = exports.appendSlashIfNeeded = function appendSlashIfNeeded(text) {
  return text[text.length - 1] !== '/' ? text + '/' : text;
};
var prependHttpIfNeeded = exports.prependHttpIfNeeded = function prependHttpIfNeeded(url) {
  var cleanedUrl = url.trim().split("?")[0];
  var absoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//?', 'i');
  if (absoluteUrlRegex.test(cleanedUrl)) return url;
  if (cleanedUrl.split("/")[0].includes('.')) return 'http://' + url.trim();
  return url;
};
var getImageNameFromUrl = exports.getImageNameFromUrl = function getImageNameFromUrl(url) {
  if (!url) return "";
  var nameWithExtension = url.split("/").pop();
  return nameWithExtension.split(".")[0].replace(/\d+$/, "");
};
var getAllQueryParams = exports.getAllQueryParams = function getAllQueryParams() {
  var params = new URLSearchParams(location.search);
  var result = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = params.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;
      var _ref2 = _slicedToArray(_ref, 2);
      var key = _ref2[0];
      var value = _ref2[1];
      result[key] = value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return result;
};
var getQueryParam = exports.getQueryParam = function getQueryParam(name) {
  var queryParams = getAllQueryParams();
  return queryParams[name] || '';
};
var getUtmParams = exports.getUtmParams = function getUtmParams() {
  var params = getAllQueryParams();
  var result = {};
  Object.keys(params).forEach(function (key) {
    if (key.startsWith('utm_')) result[key] = params[key];
  });
  return result;
};
var filterAndSortAttendeeTypes = exports.filterAndSortAttendeeTypes = function filterAndSortAttendeeTypes(attendeeTypes, displayedAttendeeTypes) {
  var attendeeTypeIds = displayedAttendeeTypes || [];
  if (attendeeTypes && !attendeeTypeIds.length) attendeeTypeIds = Object.keys(attendeeTypes);
  attendeeTypeIds = attendeeTypeIds.filter(function (id) {
    return !!attendeeTypes[id];
  });
  return attendeeTypeIds.sort(function (id1, id2) {
    return attendeeTypes[id1].order - attendeeTypes[id2].order;
  });
};
var buildStyleTagWithFontFaces = exports.buildStyleTagWithFontFaces = function buildStyleTagWithFontFaces(fontValues, familyName) {
  var styleString = '<style type=\'text/css\'>';
  var fontFamilyValues = fontValues.filter(function (f) {
    return f.name === familyName;
  });
  fontFamilyValues.forEach(function (f) {
    return styleString += '@font-face{\n                                                  font-family: ' + f.name + ';\n                                                  src: url(' + f.source + ');\n                                                  font-weight: ' + f.weight + ';\n                                                  font-style: ' + f.style + ';\n                                                }';
  });
  styleString += '</style>';
  return styleString;
};
var buildFontFaces = exports.buildFontFaces = function buildFontFaces(globalFontId, accountFonts) {
  var currentFont = accountFonts[parseInt(globalFontId)];
  var familyName = currentFont.name;
  var fontValues = Object.values(accountFonts);
  return buildStyleTagWithFontFaces(fontValues, familyName);
};